import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { useReducedMotion } from '@/hooks/use-reduced-motion'

interface CountUpProps {
    value: number
    decimals?: number
    runKey?: string | number
    duration?: number
}

const CountUp: FC<CountUpProps> = ({
    value,
    decimals = 0,
    runKey,
    duration = 1100
}): ReactNode => {
    const [display, setDisplay] = useState(value)
    const reducedMotion = useReducedMotion()

    useEffect(() => {
        if (reducedMotion) {
            setDisplay(value)

            return
        }

        let frame = 0
        const start = performance.now()

        const tick = (now: number) => {
            const progress = Math.min(1, (now - start) / duration)
            const eased = 1 - Math.pow(1 - progress, 3)

            setDisplay(value * eased)

            if (progress < 1) frame = requestAnimationFrame(tick)
        }

        frame = requestAnimationFrame(tick)

        return () => cancelAnimationFrame(frame)
    }, [value, runKey, duration, reducedMotion])

    return (
        <span className='tabular-nums'>
            {display.toFixed(decimals)}
        </span>
    )
}

export default CountUp
